import React, {useContext} from "react";
import {RecordsManagementContext} from "../StatesMangement/InitialiseContext";

export default () => {//it contains moving and packing dates ,agreed pick-up and delivery period details etc.
    let IV2_PageDetails = useContext(RecordsManagementContext).IV2_PageDetails
    return (
        <>
            <table className="table">
                <thead>
                <tr>
                    <th className="th-bost" scope="col">PACKING DATE(s)</th>
                    <th className="th-bost" scope="col">MOVING DATE(s)</th>
                    <th className="th-bost" scope="col">AGREED PICK-UP PERIOD</th>
                    <th className="th-bost" scope="col">AGREED DELIVERY PERIOD</th>
                    <th className="th-bost" scope="col">REFERRAL SOURCE</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td className="td-bost">
                        <input className='w-100'
                               defaultValue={IV2_PageDetails.PackingAndMovingDates.PackingDate} disabled/>
                    </td>
                    <td className="td-bost">{IV2_PageDetails.PackingAndMovingDates.ServiceDate}</td>
                    <td className="td-bost">
                        <table className="table table-sm">
                            <thead>
                            <tr>
                                <th className="th-bost" scope="col">EARLIEST - LATEST</th>
                                <th className="th-bost" scope="col">PREFERRED</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td className="td-bost"><input className='w-100'
                                                               defaultValue={IV2_PageDetails.PackingAndMovingDates.PickUpEarliestPeriod}
                                                               disabled/></td>
                                <td className="td-bost"><input className='w-100'
                                                               defaultValue={IV2_PageDetails.PackingAndMovingDates.PickUpPreferredPeriod}
                                                               disabled/></td>
                            </tr>
                            </tbody>
                        </table>
                    </td>
                    <td className="td-bost">
                        <table className="table table-sm">
                            <thead>
                            <tr>
                                <th className="th-bost" scope="col">EARLIEST - LATEST</th>
                                <th className="th-bost" scope="col">PREFERRED</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td className="td-bost"><input className='w-100'
                                                               defaultValue={IV2_PageDetails.PackingAndMovingDates.DeliveryEarliestPeriod}
                                                               disabled/></td>
                                <td className="td-bost"><input className='w-100'
                                                               defaultValue={IV2_PageDetails.PackingAndMovingDates.DeliveryPreferredPeriod}
                                                               disabled/></td>
                            </tr>
                            </tbody>
                        </table>
                    </td>
                    <td className="td-bost">{IV2_PageDetails.PackingAndMovingDates.ReferredBy}</td>
                </tr>
                </tbody>
            </table>
        </>
    )
}